import axios from "axios";


export const MENU_REQUEST = "MENU_REQUEST";
export const MENU_SUCCESS = "MENU_SUCCESS";
export const MENU_FAIL = "MENU_FAIL";


export const fetchMenu = (restaurantId) => async (dispatch) => {

  try {

    dispatch({
      type: MENU_REQUEST,
    });


    const response = await axios.get(
      `/api/restaurants/${restaurantId}/menu/`,
    );


    dispatch({
      type: MENU_SUCCESS,
      payload: response.data,
    });


  } catch (error) {

    dispatch({
      type: MENU_FAIL,
      payload:
        error.response?.data?.detail ||
        error.message ||
        "Failed to load menu",
    });

  }

};